( function( $, window ) {
    'use strict';

    $( function() {
    	const $window = $( window );
        const $video = $( '.js-floating-video' );
        const $videoClose = $( '.js-floating-video-close' );
        const $siteFooter = $( '.js-site-footer' );
        const visibleClassName = 'is-visible';
        const disabledClassName = 'is-disabled';
        const scrollTopOffset = 100;

        const showVideo = () => {
	        $video.addClass( visibleClassName );
        };

        const hideVideo = () => {
	        $video.removeClass( visibleClassName );
        };

        const disableVideo = () => {
	        $video.addClass( disabledClassName );
	        $window.off( 'scroll.wellfit.floatingvideo' );
	    };

        const toggleVideo = () => {
        	if ( $window.scrollTop() > scrollTopOffset && $window.scrollTop() < ( $siteFooter.offset().top - $window.height() ) ) {
        		showVideo();
	        } else {
        		hideVideo();
	        }
        };

        const registerScrollHandler = () => {
        	$window.on( 'scroll.wellfit.floatingvideo', function() {
        		toggleVideo();
	        } );
        };

        const registerCloseClickHandler = () => {
	        $videoClose.on( 'click', function() {
		        disableVideo();
		        return false;
	        } );
        };

        const registerVideoClickHandler = () => {
        	$video.on( 'click', function() {
        		disableVideo();
	        } );
        };

        const init = () => {
        	registerCloseClickHandler();
        	registerVideoClickHandler();
        	registerScrollHandler();
        	toggleVideo();
        };

        if ( $video.length ) {
	        init();
        }
    } );
} )( jQuery, window );
